(function () {
  function bind(section) {
    if (!section || section.dataset.mediaVideoBound === "true") return;

    var openBtn = section.querySelector("[data-media-video-open]");
    var modal = section.querySelector("[data-media-video-modal]");
    var media = section.querySelector("[data-media-video-media]");
    if (!openBtn || !modal || !media) return;

    section.dataset.mediaVideoBound = "true";
    var modalHome = modal.parentElement;

    function buildFrame() {
      var type = openBtn.dataset.videoType;
      var id = openBtn.dataset.videoId;
      if (!type || !id) return null;

      var iframe = document.createElement("iframe");
      iframe.allow = "autoplay; encrypted-media; picture-in-picture";
      iframe.setAttribute("allowfullscreen", "");
      iframe.title = modal.getAttribute("aria-label") || "Video";

      if (type === "youtube") {
        iframe.src = "https://www.youtube.com/embed/" + encodeURIComponent(id) + "?autoplay=1&rel=0";
      } else if (type === "vimeo") {
        iframe.src = "https://player.vimeo.com/video/" + encodeURIComponent(id) + "?autoplay=1";
      } else {
        return null;
      }

      return iframe;
    }

    function openModal() {
      var frame = buildFrame();
      if (!frame) return;

      media.innerHTML = "";
      media.appendChild(frame);
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      modal.hidden = false;
      document.body.classList.add("m-media-video--modal-open");
      document.addEventListener("keydown", onKeyDown);

      var closeBtn = modal.querySelector("[data-media-video-close].m-media-video__modal-close");
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      if (modal.hidden) return;
      media.innerHTML = "";
      modal.hidden = true;
      if (modalHome && modal.parentElement === document.body) {
        modalHome.appendChild(modal);
      }
      document.body.classList.remove("m-media-video--modal-open");
      document.removeEventListener("keydown", onKeyDown);
      openBtn.focus();
    }

    function onKeyDown(event) {
      if (event.key === "Escape") closeModal();
    }

    /* Play in place: swap the thumbnail for the playing video, same size and spot. */
    function playInline() {
      var frame = buildFrame();
      if (!frame) return;
      var player = document.createElement("div");
      player.className = openBtn.className.replace(/\bm-scroll-trigger[^ ]*/g, "") + " m-media-video__thumb--playing";
      player.appendChild(frame);
      openBtn.replaceWith(player);
    }

    openBtn.addEventListener("click", section.hasAttribute("data-media-video-inline") ? playInline : openModal);
    modal.addEventListener("click", function (event) {
      if (event.target.closest("[data-media-video-close]")) closeModal();
    });
  }

  function init(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll("[data-media-video]");
    for (var i = 0; i < sections.length; i++) bind(sections[i]);
  }

  document.addEventListener("DOMContentLoaded", function () {
    init(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
